// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
// import {
//   Box, Typography, CircularProgress,
//   Select, MenuItem, FormControl, InputLabel
// } from '@mui/material';
//  import dayjs from 'dayjs';

// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// const AdminPageClick = () => {
//   const [savedPostData, setSavedPostData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [period, setPeriod] = useState('week'); 
//   const [value, setValue] = React.useState(dayjs('2022-04-17'));

//   useEffect(() => {
//     const fetchSavedPostAnalytics = async () => {
//       try {
//         setLoading(true);
//         const res = await axios.get(
//           `${API_BASE_URL}/api/most-clicked-post?period=${period}`,
//           { withCredentials: true }
//         );
//         setSavedPostData(res.data);
//       } catch (error) {
//         console.error('Error fetching saved post analytics:', error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchSavedPostAnalytics();
//   }, [period]);

//   return (
//     <Box sx={{ p: 4 }}>
//       <Typography variant="h5" gutterBottom>
//         Popular Post Clicks
//       </Typography>

//       <FormControl sx={{ mb: 3, width: 200 }}>
//         <InputLabel id="time-range-label">Time Range</InputLabel>
//         <Select
//           labelId="time-range-label"
//           value={period}
//           label="Time Range"
//           onChange={(e) => setPeriod(e.target.value)}
//         >
//           <MenuItem value="day">Last 24 Hours</MenuItem>
//           <MenuItem value="week">Last 7 Days</MenuItem>
//           <MenuItem value="month">Last 30 Days</MenuItem>
//         </Select>
//       </FormControl>

//       {loading ? (
//         <CircularProgress />
//       ) : (
//         <ResponsiveContainer width="100%" height={400}>
//           <BarChart data={savedPostData}>
//             <XAxis
//               dataKey="eventName"
//               angle={-30}
//               textAnchor="end"
//               interval={0}
//               height={80}
//             />
//             <YAxis />
//             <Tooltip />
//             <Bar dataKey="viewCount" fill="#1976d2" />
//           </BarChart>
//         </ResponsiveContainer>
//       )}
//     </Box>
//   );
// };

// export default AdminPageClick;
import './adminAnalytics.css';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer,
  Cell
} from 'recharts';
import {
  Box, Typography, CircularProgress,
  Select, MenuItem, FormControl, InputLabel
} from '@mui/material';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const AdminPageClick = () => {
  const [savedPostData, setSavedPostData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [period, setPeriod] = useState('week');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    const fetchSavedPostAnalytics = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${API_BASE_URL}/api/most-clicked-post`, 
        {
            params: {
              period: period
            },
          });
        setSavedPostData(res.data);
      } catch (error) {
        console.error('Error fetching saved post analytics:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSavedPostAnalytics();
  }, [period]);

    useEffect(() => {
    const fetchSavedPostAnalytics = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${API_BASE_URL}/api/most-clicked-post`, 
        {
            params: {
              start:startDate,
              end:endDate
            },
          });
        setSavedPostData(res.data);
      } catch (error) {
        console.error('Error fetching saved post analytics:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSavedPostAnalytics();
  }, [startDate,endDate]);

  const getBarColor = (index) => {
    const colors = ['#993f51', '#255a90', '#649bcb','#ff8c00', '#2e8b57'];
    return colors[index % colors.length];
  };

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h5" gutterBottom>
        Popular Post Clicks
      </Typography>

      <Box sx={{ display: 'flex', gap: 3, mb: 3, flexWrap: 'wrap' }}>
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel id="time-range-label">Time Range</InputLabel>
          <Select
            labelId="time-range-label"
            value={period}
            label="Time Range"
            onChange={(e) => {
              setPeriod(e.target.value);
              setStartDate(null);
              setEndDate(null);
            }}
          >
            <MenuItem value="day">Last 24 Hours</MenuItem>
            <MenuItem value="week">Last 7 Days</MenuItem>
            <MenuItem value="month">Last 30 Days</MenuItem>
          </Select>
        </FormControl>

            <Box sx={{ display: 'flex', gap: 2 }}>
              <DatePicker
                selected={startDate}
                onChange={(date) => {
                  setStartDate(date);
                  if (endDate && date > endDate) setEndDate(null);
                  setPeriod('');
                }}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                placeholderText="Start Date"
                dateFormat="MM/dd/yyyy"
              />

              <DatePicker
                selected={endDate}
                onChange={(date) => {
                  setEndDate(date);
                  setPeriod('');
                }}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                placeholderText="End Date"
                dateFormat="MM/dd/yyyy"
              />
            </Box>
      </Box>

      {loading ? (
        <CircularProgress />
      ) : (
        <ResponsiveContainer width="100%" height={400}>
            <BarChart
              layout="vertical"
              data={savedPostData}
              margin={{ top: 20, bottom: 20,}}
            >
              <XAxis
                type="number"
                label={{
                  value: 'Views',
                  position: 'insideBottomRight',
                  offset: -10,
                }}
                tickFormatter={(value) => Math.round(value)}
                allowDecimals={false}
                axisLine={false}
                tickLine={false}
              />
              <YAxis
                type="category"
                dataKey="eventName"
                width={200}
                axisLine={false}
                tickLine={false}
              />
              <Tooltip />
              <Bar dataKey="viewCount" radius={[0, 10, 10, 0]}>
                {savedPostData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={getBarColor(index)} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
      )}
    </Box>
  );
};

export default AdminPageClick;